import axiosInstance from '../axios/instance'

export const getPublisherCategoriesBySecret = async publisher_id => {
    const url = new URL(process.env.REACT_APP_HUB_URL + '/api/publisher-categories/by-secret')
    url.searchParams.append('publisher_id', publisher_id)
    url.searchParams.append('secret_token', process.env.REACT_APP_ONBOARDING_SECRET_KEY)
    const response = await axiosInstance.get(url)
    return response?.data
}
